module.exports = __webpack_public_path__ + "static/fg-ee5647b94db18137b2717d4120aacff8.png";